// extracted by mini-css-extract-plugin
export var root = "UUJt";
export var rootButton = "F8pq";
export var rootClose = "Oq3B";
export var rootHeading = "_1kWS";
export var rootText = "cBnC";